export enum IRequirementType {
  addRequirement = 'addRequirement',
  markException = 'markException',
}

export interface IExceptionWaive {
  exceptionWaiveId: number;
  placementId: number;
  requirementId: number;
  requirementTypeId: number;
  typeId: number;
  type: string;
  active: boolean;
  expirationDate: Date | null;
  notes: string | null;
  amnApproverName: string | null;
  amnApproverTitle: string | null;
  clientApproverName: string | null;
  clientApproverTitle: string | null;
  clientDepartment: string | null;
  insertDate: Date | null;
  insertByUserId: number | null;
  insertedByName?: {
    first: string;
    last: string;
  };
  lastUpdateDate: Date | null;
  lastUpdateByUserId: number | null;
  lastUpdatedByName?: {
    first: string;
    last: string;
  };
  existingAttachments: ExceptionWaiveAttachment[];
}

export interface ExceptionWaiveAttachment {
  addedById: number;
  addedByName: string;
  attachmentSize: number;
  attachmentType: string;
  attachmentUrl: string;
  dateAdded: string;
  exceptionWaiveId: number;
  saasAttachmentUrl: string;
  title: string;
  id?: number;
}
